import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import styleable from 'react-styleable';
import defaultStyle from './timer.style.js';

export class TimerComponent extends Component {
  constructor(props) {
    super(props);
    const { time } = props;

    this.state = {
      remainingTime: time || 0,
      timerStarted: false,
      countdown: null,
    }

    this.getRemainingTime = this.getRemainingTime.bind(this);
    this.startTimer = this.startTimer.bind(this);
    this.pauseTimer = this.pauseTimer.bind(this);
    this.stopTimer = this.stopTimer.bind(this);
    this.tick = this.tick.bind(this);
    this.onTimerExpire = this.onTimerExpire.bind(this);
  }

  componentWillMount() {
    const { startOnMount, timerRef } = this.props;
    timerRef && timerRef(this);

    if(startOnMount) {
      this.startTimer();
    }
  }

  startTimer() {
    const { timerStarted } = this.state;

    if(!timerStarted) {
      this.setState({
        timerStarted: true,
        countdown: setTimeout(this.tick, 1000),
      });
    }
  }

  pauseTimer() {
    const { timerStarted, countdown } = this.state;

    if(timerStarted) {
      countdown && clearTimeout(countdown);
      this.setState({
        timerStarted: false,
        countdown: null,
      });
    }
  }

  stopTimer() {
    const { time } = this.props;
    const { timerStarted, countdown } = this.state;

    if(timerStarted) {
      countdown && clearTimeout(countdown);
      this.setState({
        remainingTime: time || 0,
        timerStarted: false,
        countdown: null,
      });
    }
  }

  getRemainingTime() {
    return this.state.remainingTime;
  }

  tick() {
    const { remainingTime, timerStarted } = this.state;

    if(!timerStarted) {
      return;
    }

    if(remainingTime > 1) {
      this.setState({
        remainingTime: remainingTime-1,
        countdown: setTimeout(this.tick, 1000),
      });
    }
    else {
      this.setState({
        remainingTime: 0,
        countdown: null,
      }, this.onTimerExpire());
    }
  }

  onTimerExpire() {
    const { onExpire } = this.props;

    this.stopTimer();
    onExpire();
  }

  render() {
    const { css } = this.props;
    const { remainingTime, timerStarted } = this.state;

    return (
      <div className={css.timer}>
        <div className={timerStarted ? css.remainingTimeWrapperActive : css.remainingTimeWrapper}>
          <span id="time" className={timerStarted ? css.remainingTimeActive : css.remainingTime}>{remainingTime}</span>
        </div>
      </div>
    );
  }
}

TimerComponent.defaultProps = {
  startOnMount: true,
};

TimerComponent.propTypes = {
  timerRef: PropTypes.func, // this can be used to access start, pause, and stop functions
  startOnMount: PropTypes.bool,
  time: PropTypes.number, // in seconds
  onExpire: PropTypes.func,
  css: PropTypes.object,
};

export default styleable(defaultStyle) (TimerComponent);



// WEBPACK FOOTER //
// src/common/timer-component/timer-component.js